<template>
  <div>
    <Counting_stock_detail/>
  </div>
</template>

<script>
import Counting_stock_detail from "@/components/adminArin/pos_system/warehouse/countingstock/Counting_stock_detail";
export default {
  name: "Countingstockdetail",
  components: {
    Counting_stock_detail
  }
}
</script>

<style scoped>

</style>
